import React, { useContext, useState } from 'react'
import { chatbotDataConnector, dataConnectorList, functionParameterData, smartAssistPayload } from '../../../../../models/axiosModel';
import { UserContext, UserContextPayload } from '../../../../../context/userContext';
import agent from '../../../../../services/api';
import { Grid, Typography, useMediaQuery } from '@mui/material';
import styles from "../../../../../assets/styles/componentStyles/chats/smartAssist.module.scss";
import globalStyles from "../../../../../assets/styles/global.module.scss";
import { useRuleBasedInboxStore } from '../../../../../store/ruleBasedInboxStore';
import { DataConnectorContext, DataConnectorContextpayload } from '../../../../../context/dataConnectorContext';
import SmartAssistCard from './smartAssistCard';
import GlobalPopUp from '../../../../../components/utility/globalPopUp';
import SmartAssistRunToolPopup from './smartAssistRunToolPopup';
import SmartAssistSkeletonCard from './smartAssistSkeletonCard';
import GlobalSearch from '../../../../../components/utility/GlobalSearch/GlobalSearch';
import { useShallow } from 'zustand/react/shallow';
import clsx from "clsx";

interface SmartAssistProps {
    renderNoInfoAvailableBlock: (text: string) => JSX.Element
} 

const SmartAssist: React.FC<SmartAssistProps> = (props) => {
    
    const { renderNoInfoAvailableBlock } = props;

    const breakPoints = {
        laptopScreen: useMediaQuery('(max-width : 1600px) and (min-width : 1000px)'),
        flagSmallScreen: useMediaQuery<boolean>('(min-width: 0px) and (max-width: 1000px)')
    }
    
    const innerHeight = window.innerHeight - 330;

    const { setFlagLoading, handleError } = useContext(UserContext) as UserContextPayload
    const { smartAssistToolList , setFilteredDataConnectorList, filteredDataConnectorList } = useContext(DataConnectorContext) as DataConnectorContextpayload;

    const { setFlagOpenThreadInfoBlock, flagOpenThreadInfoBlock } = useRuleBasedInboxStore(useShallow((state) => ({
        setFlagOpenThreadInfoBlock: state.setFlagOpenThreadInfoBlock,
        flagOpenThreadInfoBlock: state.flagOpenThreadInfoBlock
    })))

    const [payloadSmartAssist, setPayloadSmartAssist] = useState<smartAssistPayload | null>(null);
    const [dataConnectorDetails, setDataConnectorDetails] = useState<chatbotDataConnector | null>(null);
    const [flagRunDataConnectorToolPopup, setFlagRunDataConnectorToolPopup] = useState<boolean>(false);
    

    const getChatbotDataConnectorDetailCall = async (item: dataConnectorList) => {
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }))
        const res = await agent.getDataConnectorDetail.get(item?.chatbot_data_connector_id);

        if (res.status) {
            const parameters = res.data?.[0]?.data_connector_functions?.data_connector_function_parameters?.function_parameter_data?.sort((a: functionParameterData, b: functionParameterData) => (a?.function_parameter_data_id ?? 0) - (b?.function_parameter_data_id ?? 0))
                ?.reduce((acc: Record<string, string>, para: functionParameterData) => {
                    acc[para.function_parameter_name] = "";
                    return acc;
                }, {}) || {};
            setPayloadSmartAssist((prev) => ({
                ...prev,
                chatbot_data_connector_id: item?.chatbot_data_connector_id,
                request_parameters: parameters

            }));
            setDataConnectorDetails(res.data?.[0])
        } else {
            handleError(res);
        }
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }))
    }

    const handleRunTool = (item: dataConnectorList) => {
        getChatbotDataConnectorDetailCall(item);
        setFlagRunDataConnectorToolPopup(true);
         if(breakPoints.laptopScreen){
            setFlagOpenThreadInfoBlock(!flagOpenThreadInfoBlock);
        }
    }

    const onCloseOfSmartAssistRunToolPopup = () => {
        setFlagRunDataConnectorToolPopup(false); 
        setPayloadSmartAssist(null);
    }

    const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
        const query = e?.target?.value?.toLowerCase();
        if (smartAssistToolList) {
            const filteredDataConnectorList = smartAssistToolList.filter((list: dataConnectorList) => {
                return (list.chatbot_data_connector_id != null && (list.data_connector_functions?.data_connector_function_name?.toLowerCase().includes(query) || list.data_connector_functions?.data_connector_function_description?.toLowerCase().includes(query)))
            })
            setFilteredDataConnectorList(filteredDataConnectorList);
        }
    }

    return (
        <>
            {!smartAssistToolList ?
                <Grid container direction="column" gap={"16px"}>
                    {Array.from({ length: 4 }).map((_, index) => (
                        <SmartAssistSkeletonCard index={index} />
                    ))}
                </Grid>
                :
                smartAssistToolList?.length > 0 ?
                    <Grid container gap={0.5} direction={"column"}>
                        <Typography className={styles.toolsAvailableDescription}>
                            Tools Available for you
                        </Typography>
                        <Grid item className={clsx(globalStyles.globalSearchbarSubItem, styles.functionCallingResponseSearchBar)}>
                            <GlobalSearch
                                fullWidth
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => { handleSearch(e) }}
                                size="small"
                                placeholder="Search"
                            />
                        </Grid>

                        {(filteredDataConnectorList && filteredDataConnectorList?.length > 0) ?
                            <div className={clsx(styles.smartAssistListContainer, globalStyles.maxWidthFull)} style={{ maxHeight: `${innerHeight}px`}}>
                                {filteredDataConnectorList?.map((item: dataConnectorList, index: number) => (
                                    <SmartAssistCard item={item} key={index} onRunTool={handleRunTool} />
                                ))}
                            </div>
                            :
                            renderNoInfoAvailableBlock("No Smart Assist tools found.")
                        }
                    </Grid>
                    :
                    <>
                        {renderNoInfoAvailableBlock("No Smart Assist tools are available yet.")}
                    </>
            }

            {flagRunDataConnectorToolPopup &&
                <GlobalPopUp
                    open={flagRunDataConnectorToolPopup}
                    handleClose={() => onCloseOfSmartAssistRunToolPopup()}
                    onClose={() => onCloseOfSmartAssistRunToolPopup()}
                    flagShowCloseIcon={true}
                    titlePadding='0px'
                    paperMinWidth={breakPoints.flagSmallScreen ? "310px" : "85%"}
                    paperMaxwidth={breakPoints.flagSmallScreen ? "610px" : "85%"}
                >
                    <SmartAssistRunToolPopup
                        dataConnectorDetails={dataConnectorDetails}
                        payload={payloadSmartAssist}
                        setPayload={setPayloadSmartAssist}
                        setFlagRunDataConnectorToolPopup={setFlagRunDataConnectorToolPopup}
                    />
                </GlobalPopUp>
            }
        </>
    )
}

export default SmartAssist
